import { Injectable } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import * as _ from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';
import { ApiResult } from '../../../core/messages/api-result';
import { DisplayMessage } from '../../../core/messages/display-message';
import { Severity } from '../../../shared/enums/severity';
import { InspectionReportBase } from '../../../viewmodels/analysis/inspection-reports/inspection-report-base';
import { DynamicDetailsListItemAdapter } from '../../dynamic-details-list/dynamic-details-list-item';
import { DynamicDetailsListItemRowData } from '../../dynamic-details-list/dynamic-details-list-item-row-data';

@Injectable()
export class InspectionReportListService {

  constructor(private i18NextPipe: I18NextPipe) {}

  public allowSave = new Subject<boolean>();
  public hasMedia: Subject<boolean> = new Subject<boolean>();
  public saveClicked = new Subject();
  public saveComplete = new Subject<any>();
  public saveCompleteWithReportId = new Subject<string>();
  public selectedListItem: BehaviorSubject<DynamicDetailsListItemAdapter> = new BehaviorSubject<DynamicDetailsListItemAdapter>(null);
  public selectedReportId: Subject<string> = new Subject<string>();

  public updateSelectedItemSiteRowData(siteName: string) {
    if (siteName && this.selectedListItem.value) {
      const siteRow = this.selectedListItem.value.rowData.findIndex(x => x.label.toLowerCase() === 'site');
      if (siteRow > -1) {
        this.selectedListItem.value.rowData[siteRow].value = siteName;
      } else {
        this.selectedListItem.value.rowData.push(new DynamicDetailsListItemRowData(this.i18NextPipe.transform('HierarchyItem.Site'), siteName, false));
      }
    }
  }

  sortByInspectionDate<T extends InspectionReportBase>(event, reports: T[]) {
    reports = reports
      .sort((a, b) => new Date(a.inspectionDate).getTime() - new Date(b.inspectionDate).getTime() * event.order)
      .slice();
  }

  filterByName<T extends InspectionReportBase>(reports: T[], text: string): T[] {
    return _.filter(reports, (report: T) => report.hierarchyItem.name.toLowerCase().includes(text.toLowerCase()));
  }

  public setSaveMessages(errorResult: ApiResult): DisplayMessage[] {
    const messages: DisplayMessage[] = [];
    messages.push(new DisplayMessage(this.i18NextPipe.transform(this.i18NextPipe.transform('InspectionReportListService.ReportCouldNotBeSaved')), '', Severity.Error));
    errorResult.messages.forEach(message => messages.push(new DisplayMessage('', message.text, message.severity)));
    return messages;
  }
}
